import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-deep" data-id="element-85" data-mp="32wd2qgad7ltj">
      <div className="max-w-3xl mx-auto px-5 py-12 text-center" data-id="element-86" data-mp="3gezeh7brdx2q">
        <h3 className="font-display text-2xl uppercase tracking-wide text-gold" data-id="element-87" data-mp="3ghc2o28413o8">
          Sideline Ready
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/70" data-id="element-88" data-mp="36pfsvtwnvp46">
          The 4-Quarter Practice — because the practice shouldn&apos;t take
          longer to plan than it does to run.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2.5 text-[13px] text-white/70" data-id="element-89" data-mp="38qtcrvhxfo0">
          <a href="mailto:[SUPPORT_EMAIL]" className="hover:text-white hover:underline" data-id="element-90" data-mp="3lem0a55nkln5">
            [SUPPORT_EMAIL]
          </a>
          <a href="[INSTAGRAM_URL]" className="hover:text-white hover:underline" data-id="element-91" data-mp="3qfji2gmr3do4">
            [@handle]
          </a>
          <a href="[SITE_URL]" className="hover:text-white hover:underline" data-id="element-92" data-mp="2eya05yj9stox">
            [www.site.com]
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-navy-line pt-5 text-xs leading-relaxed text-white/45" data-id="element-93" data-mp="3l8qvw2zluhqx">
          Sideline Ready is an educational resource for coaches. It does not
          replace coaching certification, CPR/first-aid training, or the current
          rules of your league, club or school. Tackle and contact material
          follows the rules and certification of your own league. Coaches are
          responsible for verifying that any skill is trained, supervised,
          age-appropriate and legal in their setting before it is performed.
          © Sideline Ready 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}